// src/components/mf-shared/mf-shared.ts
class MfShared {
  static getGridSizeName(): string | undefined {
    const box = document.getElementById('GetGridstatus');
    if (!box) return undefined;

    const items = box.getElementsByClassName('item') as HTMLCollectionOf<HTMLElement>;
    for (const el of Array.from(items)) {
      const style = getComputedStyle(el);
      if (style.display === 'block') {
        return el.dataset.gridstatus || undefined;
      }
    }
    return undefined;
  }

  static getGridSizeMasonrySize(): number {
    const sizes: Record<string, number> = { xs: 400, sm: 230, md: 230, lg: 320, xl: 330 };
    const name = this.getGridSizeName() ?? 'xs';
    return sizes[name] ?? 400;
  }
}
export default MfShared;
